import React from 'react';
import { DefaultButton, Link, MessageBar, MessageBarType, PrimaryButton, TextField } from '@fluentui/react';
import { IUserService, Services } from '../../services';
import styles from './ChangePassword.module.scss';
import { IChangePasswordDTO } from '../../models';
import { UserServiceProvider } from '../../services/userService';
import { withLanguage, WithLanguage } from '../../LanguageContext';

interface IChangePasswordProps extends WithLanguage {
}

interface IChangePasswordState {
    existingPassword?: string;
    newPassword?: string;
    newPasswordAgain?: string;
    canSubmit: boolean;
}

class ChangePassword extends React.Component<IChangePasswordProps, IChangePasswordState> {
    private userService: IUserService;

    constructor(props: IChangePasswordProps) {
        super(props);

        this.userService = Services.UserService.Initialize(new UserServiceProvider());

        this.state = {
            canSubmit: false
        };
    }

    public render(): React.ReactElement<IChangePasswordProps> {
        const { t } = this.props;
        
        return (<div className={styles.changePassword}>
            <h3>{t('changePassword.title')}</h3>
            <TextField
                className={styles.marginBottom}
                required={false}
                placeholder={t('changePassword.currentPasswordPlaceholder')}
                type="password"
                autoComplete="new-password"
                canRevealPassword
                revealPasswordAriaLabel={t('common.showPassword')}
                value={this.state.existingPassword}
                onChange={(ev, newValue) => { this.setState({ existingPassword: newValue }, () => { this.validateForm() }); }}
            />
            <TextField
                className={styles.marginBottom}
                required={false}
                placeholder={t('changePassword.newPasswordPlaceholder')}
                type="password"
                autoComplete="new-password"
                disabled={this.state.existingPassword == undefined || this.state.existingPassword == ""}
                canRevealPassword
                revealPasswordAriaLabel={t('common.showPassword')}
                value={this.state.newPassword}
                onChange={(ev, newValue) => { this.setState({ newPassword: newValue }, () => { this.validateForm() }); }}
            />
            <TextField
                className={styles.marginBottom}
                required={false}
                placeholder={t('changePassword.newPasswordAgainPlaceholder')}
                validateOnLoad={false}
                type="password"
                autoComplete="new-password"
                disabled={this.state.existingPassword == undefined || this.state.existingPassword == ""}
                canRevealPassword
                revealPasswordAriaLabel={t('common.showPassword')}
                value={this.state.newPasswordAgain}
                onGetErrorMessage={this.validateChangePassword.bind(this)}
                onChange={(ev, newValue) => { this.setState({ newPasswordAgain: newValue }); }}
            />
            {this.state.canSubmit &&
                <MessageBar
                    className={styles.marginBottom}
                    messageBarType={MessageBarType.warning}
                    isMultiline={true}>
                    {t('changePassword.warningMessage')}
                </MessageBar>
            }
            <PrimaryButton disabled={!this.state.canSubmit} onClick={() => { this.onChangePassword(); }}>{t('changePassword.changePasswordButton')}</PrimaryButton>
        </div>)
    }

    private async onChangePassword() {
        const { t } = this.props;
        let result: boolean = await this.userService.ChangePassword({ existingPassword: this.state.existingPassword, newPassword: this.state.newPassword } as IChangePasswordDTO);

        if (result) {
            this.userService.SignOut();
        } else {
            alert(t('changePassword.error'));
        }
    }

    private validateChangePassword() {
        const { t } = this.props;
        let isValid: boolean = false;

        if (!this.state.newPassword || !this.state.newPasswordAgain) {
            isValid = false;
        } else {
            isValid = this.state.newPassword === this.state.newPasswordAgain;
        }

        this.setState({ canSubmit: isValid });

        return isValid ? "" : t('changePassword.passwordMismatch');
    }

    private validateForm() {
        if (this.state.existingPassword == undefined || this.state.existingPassword == "") {
            this.setState({ canSubmit: false });
        } else {
            this.validateChangePassword();
        }
    }
}

export default withLanguage(ChangePassword);